module.exports = __webpack_public_path__ + "static/media/simbolo-x.b840e171.svg";